<template>
  <b-row align-h="center">
    <b-col lg="9" class="px-lg-0 px-3 close-content">
      <p class="my-2 mt-5 account-closed-text">
        {{ $t("nowDeleted") }}
      </p>
      <img src="assets/images/icons/icon-sad.png" class="sad-icon my-5" />
      <hr />
      <p class="my-3 deleted-personal-information">
        {{ $t("deletedPersonalInfo") }}
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "DeleteAccountStepFour",
  mounted() {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    document.cookie = "";
    setTimeout(() => {
      window.location = "https://shop.trebel.io";
    }, 10000);
  }
};
</script>

<style scoped></style>
